// Import the necessary components
import VerofreshRecord from './VerofreshRecord'

class LocationTypeRecord extends VerofreshRecord {
  static get endpoint () { return 'location/types' }
}

export default LocationTypeRecord
